import React, {
  forwardRef,
  useEffect, useState,
  useImperativeHandle,
  useRef,
} from "react";
import html2pdf from 'html2pdf.js';
import { useReactToPrint } from "react-to-print";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
import { useSelector } from "react-redux";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { defaultLightTheme } from "../../assets/styled-components/themes/themelist";
import { Button, Grid } from "@mui/material";
import "../commoncomponents/print.css";
import "jspdf-autotable";
import { useAccess } from "../../AccessContext";
import utilities from '../../utility/utilities';
import QualityPPM from "./QualityPPM";
import Qualityworkorder from "./Qualityworkorder";

const Qualitydownloadfile = forwardRef((props, ref) => {
  const { report, reportdata, onRenderComplete, setOpenModal, year, service, month, department, setText, text, date, setDate, selectedReport } = props;
  const printRef = useRef(null);
  const accessData = useAccess();
  const access = utilities.getScreenPermissions(accessData, "ENGA009");
  const { color } = useSelector((state) => state.theme);
  const [reportType, setReportType] = useState(selectedReport?.value);
  useEffect(() => {
    if (onRenderComplete) {
      onRenderComplete();
    }
  }, [onRenderComplete]);

  // Handle Print
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  // Handle Download PDF
  const handleDownloadPDF = () => {
    const input = printRef.current; // Access the current DOM node from the ref

    const options = {
      margin: [0.5, 0.5, 0.5, 0.5], // Smaller margin to maximize space for the graph
      filename: 'Quality_Improvement_Analysis_Report.pdf',
      image: { type: 'jpeg', quality: 1 }, // Set maximum quality for better clarity
      html2canvas: {
        scale: 3, // Increase scale for higher-quality rendering
        useCORS: true,
        logging: true,
      },
      jsPDF: {
        unit: 'in',
        format: 'a3',
        orientation: 'portrait',
      },
      pagebreak: {
        mode: 'avoid-all', // Avoid breaking content within any child elements
        before: ['.page-break'], // If there's a class where the new page should start
        avoid: ['.no-break', '.graph-container'], // Ensure `.graph-container` does not break
      },
    };

    html2pdf()
      .from(input)
      .set(options)
      .toPdf()
      .get('pdf')
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          pdf.setFontSize(10);
          pdf.text(
            `Page ${i} of ${totalPages}`,
            pdf.internal.pageSize.getWidth() - 20,
            pdf.internal.pageSize.getHeight() - 10
          );
        }
      })
      .save()
      .catch((error) => {
        console.error('Error generating PDF:', error);
      });
  };

  // const handleDownloadPDF = async () => {
  //   const input = printRef.current; // Reference to the content to be printed
  //   const pdf = new jsPDF("p", "pt", "a4"); // Create a PDF with A4 dimensions (portrait, points)

  //   // Use html2canvas to capture the content as a canvas
  //   const canvas = await html2canvas(input, {
  //     scale: 2, // Scale up for better quality
  //     useCORS: true, // Handle cross-origin issues
  //     scrollX: 0,
  //     scrollY: -window.scrollY, // Correct the vertical scroll position if necessary
  //   });

  //   const imgData = canvas.toDataURL("image/png"); // Convert canvas to PNG image data
  //   const imgWidth = 595.28; // A4 page width in points
  //   const pageHeight = 841.89; // A4 page height in points

  //   // Adding padding to both sides
  //   const padding = 20; // Adjust as needed for left and right padding
  //   const contentWidth = imgWidth - padding * 2; // A4 width minus padding
  //   const imgHeight = (canvas.height * contentWidth) / canvas.width; // Maintain the aspect ratio of the image

  //   let heightLeft = imgHeight;
  //   let position = 0;

  //   // Add the first page image
  //   pdf.addImage(imgData, "PNG", padding, position, contentWidth, imgHeight);
  //   heightLeft -= pageHeight;

  //   // Add additional pages if content overflows
  //   while (heightLeft > 0) {
  //     position = heightLeft - imgHeight; // Adjust position for the remaining content
  //     pdf.addPage(); // Add a new page to the PDF
  //     pdf.addImage(imgData, "PNG", padding, position, contentWidth, imgHeight); // Render the remaining content with padding
  //     heightLeft -= pageHeight; // Reduce the height left to render
  //   }

  //   // Save the generated PDF with a custom file name
  //   pdf.save("Quality_Improvement_Analysis_Report.pdf");
  // };

  const handleClose = () => {
    setOpenModal(false);
  };


  useImperativeHandle(ref, () => ({
    handleDownloadPDF,
  }));
  useEffect(() => {

    const newReportType = Number(selectedReport?.value);
    if (newReportType !== reportType) {
      setReportType(newReportType);
    }
  }, [selectedReport]);
  ;
  

  return (
    <MuiThemeProvider
      theme={{
        ...defaultLightTheme,
        palette: {
          ...defaultLightTheme.palette,
          background: {
            default: color !== "default" && "rgba(17, 17, 17, 1)",
          },
        },
      }}
    >
      <CssBaseline />
      <>
        <Grid container justifyContent="flex-end" spacing={2} >
          {access?.canPrint && (<>
            <Grid item>
              <Button variant="contained" onClick={handlePrint}>Print</Button>
            </Grid>
            <Grid item>
              <Button variant="contained" onClick={handleDownloadPDF}>Download</Button>
            </Grid>
          </>)}

          <Grid item>
            <Button variant="contained" onClick={handleClose}>Close</Button>
          </Grid>
        </Grid>
        <div ref={printRef} className="print-content" style={{ overflow: 'visible' }}>
  {reportType === 1 ? (
    <QualityPPM 
      report={report} 
      reportdata={reportdata} 
      service={service} 
      year={year} 
      month={month} 
      department={department} 
      setText={setText} 
      text={text} 
      date={date} 
      setDate={setDate} 
    />
  ) : reportType === 2 ? (
    <Qualityworkorder 
      report={report} 
      reportdata={reportdata} 
      service={service} 
      year={year} 
      month={month} 
      department={department} 
      setText={setText} 
      text={text} 
      date={date} 
      setDate={setDate} 
    />
  ) : null}
</div>


      </>
    </MuiThemeProvider>
  );
}
);

export default Qualitydownloadfile;
